import { render, staticRenderFns } from "./TitleOnboarding.vue?vue&type=template&id=5b4f84b5&scoped=true&"
import script from "./TitleOnboarding.vue?vue&type=script&lang=ts&"
export * from "./TitleOnboarding.vue?vue&type=script&lang=ts&"
import style0 from "./TitleOnboarding.vue?vue&type=style&index=0&id=5b4f84b5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4f84b5",
  null
  
)

export default component.exports